import { createFileRoute } from "@tanstack/react-router";
import { KarrierePage, karriereHead } from "@/pages/KarrierePage";

export const Route = createFileRoute("/en/careers")({
  head: () => karriereHead("en"),
  component: () => <KarrierePage locale="en" />,
});
